import { render, staticRenderFns } from "./HipotekaAsmenys.vue?vue&type=template&id=72478488&scoped=true&"
import script from "./HipotekaAsmenys.vue?vue&type=script&lang=js&"
export * from "./HipotekaAsmenys.vue?vue&type=script&lang=js&"
import style0 from "./HipotekaAsmenys.vue?vue&type=style&index=0&id=72478488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72478488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VContainer,VDataTable,VIcon,VSpacer,VTextField,VToolbar})
